import { render, staticRenderFns } from "./supplement_materials_order.vue?vue&type=template&id=3cdfdc8c&scoped=true&"
import script from "./supplement_materials_order.vue?vue&type=script&lang=js&"
export * from "./supplement_materials_order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdfdc8c",
  null
  
)

export default component.exports